const activeClass = 'active';
const activeSelector = `.${activeClass}`;
const tabParentSelector = '.tabs';
const tabSelector = '.tabs > *';

function toggleTabs(e){
    const clickedTab = e.target.closest(tabSelector);
    if (clickedTab){
        const tabParent = clickedTab.closest(tabParentSelector);
        const active = tabParent.querySelector(activeSelector);
        active.classList.remove(activeClass);
        clickedTab.classList.add(activeClass);
    }
}

export default toggleTabs;